"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateSequenceDrawerRedux = void 0;
const react_redux_1 = require("react-redux");
const React = require("react");
const core_1 = require("@material-ui/core");
require("./StateSequenceDrawer.scss");
const meshes_1 = require("../../WebGLView/meshes");
const HighlightedSequenceDuck_1 = require("../../Ducks/HighlightedSequenceDuck");
const AggregationDuck_1 = require("../../Ducks/AggregationDuck");
const Timeline_1 = require("@material-ui/lab/Timeline");
const TimelineItem_1 = require("@material-ui/lab/TimelineItem");
const TimelineSeparator_1 = require("@material-ui/lab/TimelineSeparator");
const TimelineConnector_1 = require("@material-ui/lab/TimelineConnector");
const TimelineContent_1 = require("@material-ui/lab/TimelineContent");
const TimelineOppositeContent_1 = require("@material-ui/lab/TimelineOppositeContent");
const TimelineDot_1 = require("@material-ui/lab/TimelineDot");
const styles_1 = require("@material-ui/core/styles");
const Close_1 = require("@material-ui/icons/Close");
const SkipPrevious_1 = require("@material-ui/icons/SkipPrevious");
const PlayArrow_1 = require("@material-ui/icons/PlayArrow");
const SkipNext_1 = require("@material-ui/icons/SkipNext");
const Stop_1 = require("@material-ui/icons/Stop");
const ActiveLineDuck_1 = require("../../Ducks/ActiveLineDuck");
const useStyles = styles_1.makeStyles((theme) => ({
    paper: {
        padding: '6px 16px',
    },
    primaryTail: {
        backgroundColor: theme.palette.primary.main,
    },
}));
/**
 * The StateSequenceDrawer is the UI element that is shown when one line is selected by the line selection tool. In this case
 * the user wants to navigate the sequence of one line only.
 */
const StateSequenceDrawer = ({ activeLine, setHighlightedSequence, dataset, setActiveLine, setCurrentAggregation }) => {
    if (activeLine == null) {
        return React.createElement("div", null);
    }
    const classes = useStyles();
    const [selected, setSelected] = React.useState(0);
    const [playing, setPlaying] = React.useState(null);
    React.useEffect(() => {
        setSelected(0);
        setHighlightedSequence({
            previous: null,
            current: activeLine.vectors[0],
            next: activeLine.vectors[1]
        });
        setCurrentAggregation([activeLine.vectors[0]]);
        setPlaying(null);
    }, [activeLine]);
    return React.createElement(core_1.Card, { className: "StateSequenceDrawerParent" },
        React.createElement(core_1.CardHeader, { action: React.createElement(core_1.IconButton, { "aria-label": "close", onClick: () => {
                    setHighlightedSequence(null);
                    setActiveLine(null);
                } },
                React.createElement(Close_1.default, null)), title: `Line ${activeLine.lineKey}` }),
        React.createElement(core_1.CardContent, { className: "StateSequenceDrawerPaper" },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column'
                } },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center'
                    } },
                    React.createElement(core_1.IconButton, { "aria-label": "previous", onClick: () => {
                            if (selected > 0) {
                                setHighlightedSequence({
                                    previous: activeLine.vectors[selected - 2],
                                    current: activeLine.vectors[selected - 1],
                                    next: activeLine.vectors[selected]
                                });
                                setCurrentAggregation([activeLine.vectors[selected - 1]]);
                                let myElement = document.getElementById(`ssdChild${selected - 2}`);
                                if (myElement) {
                                    let topPos = myElement.offsetTop;
                                    document.getElementById('ssdParent').scrollTop = topPos;
                                }
                                else {
                                    myElement = document.getElementById(`ssdChild${selected - 1}`);
                                    let topPos = myElement.offsetTop;
                                    document.getElementById('ssdParent').scrollTop = topPos;
                                }
                                setSelected(selected - 1);
                            }
                            else {
                                setHighlightedSequence({
                                    previous: undefined,
                                    current: activeLine.vectors[activeLine.vectors.length - 2],
                                    next: activeLine.vectors[activeLine.vectors.length - 1]
                                });
                                setCurrentAggregation([activeLine.vectors[activeLine.vectors.length - 2]]);
                                let myElement = document.getElementById(`ssdChild${activeLine.vectors.length - 3}`);
                                let topPos = myElement.offsetTop;
                                document.getElementById('ssdParent').scrollTop = topPos;
                                setSelected(activeLine.vectors.length - 1);
                            }
                        } },
                        React.createElement(SkipPrevious_1.default, null)),
                    React.createElement(core_1.IconButton, { "aria-label": "play/pause", onClick: () => {
                            if (playing) {
                                clearInterval(playing);
                                setPlaying(null);
                            }
                            else {
                                let interval = setInterval(() => {
                                    document.getElementById('nextBtn').click();
                                }, 300);
                                setPlaying(interval);
                            }
                        } }, playing ? React.createElement(Stop_1.default, null) : React.createElement(PlayArrow_1.default, null)),
                    React.createElement(core_1.IconButton, { "aria-label": "next", id: "nextBtn", onClick: () => {
                            if (selected + 1 < activeLine.vectors.length) {
                                setHighlightedSequence({
                                    previous: activeLine.vectors[selected],
                                    current: activeLine.vectors[selected + 1],
                                    next: activeLine.vectors[selected + 2]
                                });
                                setCurrentAggregation([activeLine.vectors[selected + 1]]);
                                let myElement = document.getElementById(`ssdChild${selected}`);
                                let topPos = myElement.offsetTop;
                                document.getElementById('ssdParent').scrollTop = topPos;
                                setSelected(selected + 1);
                            }
                            else {
                                setHighlightedSequence({
                                    previous: activeLine.vectors[0 - 1],
                                    current: activeLine.vectors[0],
                                    next: activeLine.vectors[0 + 1]
                                });
                                setCurrentAggregation([activeLine.vectors[0]]);
                                let myElement = document.getElementById(`ssdChild${0}`);
                                let topPos = myElement.offsetTop;
                                document.getElementById('ssdParent').scrollTop = topPos;
                                setSelected(0);
                            }
                        } },
                        React.createElement(SkipNext_1.default, null))),
                React.createElement(core_1.Divider, { style: { margin: '8px 0 0 0' } }),
                React.createElement("div", { id: 'ssdParent', style: {
                        overflowY: 'auto',
                        height: '50vh',
                        position: 'relative'
                    } },
                    React.createElement(Timeline_1.default, { style: { padding: 0 } }, activeLine.vectors.map((vector, index) => {
                        return React.createElement("div", { id: `ssdChild${index}`, onClick: () => {
                                setHighlightedSequence({
                                    previous: activeLine.vectors[index - 1],
                                    current: vector,
                                    next: activeLine.vectors[index + 1]
                                });
                                setCurrentAggregation([vector]);
                                setSelected(index);
                            } },
                            React.createElement(TimelineItem_1.default, { key: index },
                                React.createElement(TimelineOppositeContent_1.default, { style: {
                                        width: 0,
                                        minWidth: 0,
                                        display: 'none'
                                    } }),
                                React.createElement(TimelineSeparator_1.default, null,
                                    React.createElement(TimelineDot_1.default, { variant: selected == index ? 'default' : 'outlined', color: selected == index ? 'primary' : 'grey' }),
                                    React.createElement(TimelineConnector_1.default, { className: selected == index || selected == index + 1 ? classes.primaryTail : '' })),
                                React.createElement(TimelineContent_1.default, null,
                                    React.createElement(core_1.Paper, { elevation: 3, className: classes.paper },
                                        React.createElement(core_1.Typography, null,
                                            React.createElement("img", { src: meshes_1.imageFromShape(vector.view.shapeType), style: {
                                                    width: '1rem',
                                                    height: '1rem',
                                                    textAlign: 'center'
                                                } }),
                                            " ",
                                            dataset.hasColumn('changes') ? vector['changes'] : `Point ${index}`)))));
                    }))))));
};
const mapStateToProps = state => ({
    activeLine: state.activeLine,
    currentTool: state.currentTool,
    highlightedSequence: state.highlightedSequence,
    dataset: state.dataset
});
const mapDispatchToProps = dispatch => ({
    setHighlightedSequence: highlightedSequence => dispatch(HighlightedSequenceDuck_1.setHighlightedSequenceAction(highlightedSequence)),
    setActiveLine: activeLine => dispatch(ActiveLineDuck_1.setActiveLine(activeLine)),
    setCurrentAggregation: currentAggregation => dispatch(AggregationDuck_1.setAggregationAction(currentAggregation))
});
exports.StateSequenceDrawerRedux = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(StateSequenceDrawer);
